<template>
  <div>
    <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header="$t('unitChanges.changeHeader') + ': ' + this.identity.userName"
        :title= "getTitle"
        align="center"
        class="mx-auto"
        style="max-width: 40rem;"
    >
      <b-form @submit.prevent="applyChange">
        <b-form-input v-if="changeRequested === 'email'"
                    id="input-email"
                    v-model="identity.email"
                    type="email"
                    :placeholder="$t('unitChanges.email')">
        </b-form-input>
        <!-- NOTE: VuePhoneNumberInput will not take css variables for colors, so the default color is black, the valid and error colors are bootstrap defaults. -->
        <VuePhoneNumberInput  v-if="changeRequested === 'phoneNumber'"
          v-model="phoneDetails"
          show-code-on-list
          size="md"
          color="#000000"
          valid-color="#28a745"
          error-color="#dc3545"
          :preferred-countries="['US']"
          @update="resultsExample = $event"
          :translations="{
            countrySelectorLabel: $t('unitChanges.countryCode'),
            countrySelectorError: $t('unitChanges.invalidCountry'),
            phoneNumberLabel: $t('unitChanges.phoneLabel'),
            example: $t('unitChanges.phoneExampleHeader')
          }"/>
        <b-button type="submit" class="m-2" variant="outline-primary">{{$t('buttonDefaults.change')}}</b-button>
        <b-button @click="onCancel" class="m-2" variant="outline-primary" >{{ $t("buttonDefaults.cancel")}}</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>

import store from "@/store/store";
import userApiService from "@/services/userApiService";
import router from "@/router";
import VuePhoneNumberInput from 'vue-phone-number-input';

export default {
  name: 'ChangeIdentityDetails',
  components: {
    VuePhoneNumberInput,
  },
  props: {
    changeRequested: { type: String }
  },
  data() {
    return {
      phoneDetails: '',
      resultsExample: '',
      text: '',
      identity: {
        userId: "",
        userName: "",
        email: "",
        phone: ""
      }
    }
  },
  mounted() {
    this.identity.userId = store.getters.getSelectedUserId
    this.identity.email = store.getters.getSelectedUserEmail
    this.identity.phone = store.getters.getSelectedUserPhone
    this.identity.userName = store.getters.getSelectedUserName
  },

  computed: {
    getTitle() {
      if (this.changeRequested === "email") {
        return this.$t('unitChanges.emailTitle')
      } else {
        return this.$t('unitChanges.phoneNumberTitle')
      }
    },
    getLabel() {
      if (this.changeRequested === "email") {
        return this.$t('unitDetails.contactEmail')
      } else {
        return this.$t('unitDetails.phoneNumber')
      }
    }
  },
  methods: {
    async applyChange(evt) {
      evt.preventDefault()
      try {
        if(this.changeRequested === 'phoneNumber' 
            && (this.resultsExample === undefined || this.resultsExample.isValid===false)) {
          this.$bvToast.toast( this.$t('unitChanges.phoneNumberInvalid'), {
            title: this.$t('unitChanges.phoneInvalidTitle'),
            autoHideDelay: 5000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
          return;
        }

        if(this.changeRequested === 'phoneNumber') {
          this.identity.phone=this.resultsExample.formatInternational
          await userApiService.updateIdentityPhone(this.identity.userId, this.identity.userName, this.identity.phone)
        } else {
          await userApiService.updateIdentityEmail(this.identity.userId, this.identity.userName, this.identity.email)
        }
        
        router.push({name: 'Unit'})
      }catch(e){
        if(e.response.status === 400) {
          this.$bvToast.toast( e.response.data.message, {
            title: this.$t('identity.detailsUpdateErrorTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
        else {
          this.$bvToast.toast( this.$t('identity.detailsUpdateErrorMsg'), {
            title: this.$t('identity.detailsUpdateErrorTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
      }
    },
    onCancel() {
      router.push({ name: 'Unit'})
    }
  }
}
</script>
